export default __webpack_public_path__ + "static/dashboard-portal-c11c19abdbcd14fdb9d6d3b0b1ebaa27.png";